import React, {useCallback, useEffect, useRef, useState} from "react";
import { useTranslation } from 'react-i18next';
import {Rate} from "antd";

// Components
import TextWithLinks from "sharedComponents/TextWithLinks";
import CircleIcon from "sharedComponents/CircleIcon";

// Hooks
import useDropoutSurveyField from "Hooks/useDropoutSurveyField";

// Utils
import validateExplanationField from "utils/validateExplanationField";

// Config
import {overallPerformanceRating} from "../config";
import {findDOMNode} from "react-dom";



const Grading = ({fieldData, getAnswer, handleChangeSurveyCompletionStatus, mandatoryRefs, disabled = false}) => {
    const explanationRef = useRef();
    const gradingRef = useRef();
    const [showError, SetShowError] = useState('');
    const [rateVal, SetRateVal] = useState(null);
    const [showExplanation, SetShowExplanation] = useState(false);
    const { t } = useTranslation();
    const isLast = fieldData.label.includes(overallPerformanceRating);

    useDropoutSurveyField(rateVal, '', handleChangeSurveyCompletionStatus);

    const handleChangeRate = useCallback((value) => {
        SetRateVal(value);
        SetShowExplanation(!!fieldData.explanation && value !== 0);

        if (fieldData.explanation && value !== 0) {
            const explanationValidation = validateExplanationField(explanationRef.current?.value, isLast);
            SetShowError(explanationValidation);
        }
    }, [showError, fieldData]);

    const handleChangeExplanation = (e) => {
        SetShowError(validateExplanationField(e.target.value, isLast));
        if (!e.target.value) {
            const fieldNode = findDOMNode(gradingRef.current);
            if (fieldData.mandatory) {
                if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                    mandatoryRefs.unshift(fieldNode);
                }
            }
        }
    };

    useEffect(() => {
        if (fieldData?.answers?.answer) {
            SetShowExplanation(!!fieldData?.answers?.explanation);
            explanationRef.current.value = fieldData?.answers?.explanation;
            SetRateVal(fieldData?.answers?.answer);
        }
    }, []);

    useEffect(() => {
        if (getAnswer.constructor !== Boolean) {
            getAnswer(prevState => ({
                ...prevState,
                [fieldData.id] : {answer: rateVal || '', explanation: explanationRef.current.value}
            }));

            const explanationValidation = validateExplanationField(explanationRef.current?.value, isLast);
            explanationValidation && SetShowError(explanationValidation);

            if (fieldData.mandatory && !rateVal) {
                SetShowError(t('Required'));
            } else {
                SetShowError('');
            }
        }
    }, [getAnswer, rateVal, fieldData]);

    useEffect(() => {
        const fieldNode = findDOMNode(gradingRef.current);
        if (fieldData.mandatory) {
            if (Array.isArray(mandatoryRefs) && !mandatoryRefs.includes(fieldNode)) {
                mandatoryRefs.push(fieldNode);
            }
        }
    }, [fieldData]);

    return (<div
        ref={gradingRef}
        className={`single_sect ${showError ? "invalid" : ""} ${isLast ? 'single_sect_last' : ''}`}
    >
        <h3 className="single_sect_primary_text">
            {fieldData.label}
            {!!fieldData.mandatory && <sup>*</sup>}
        </h3>
        <TextWithLinks className="single_sect_secondary_text">
            {fieldData.description}
        </TextWithLinks>
        <div className="rate_with_explanation">
            <Rate
                defaultValue={fieldData?.answers?.answer}
                count={JSON.parse(fieldData.type_content)?.system_points}
                className="satisfaction_rate_sect"
                onChange={handleChangeRate}
                character={JSON.parse(fieldData.type_content)?.grade_type === "dots" ? <CircleIcon/> : undefined}
                disabled={disabled}
            />
            <div
                className={`input_field hidden_input_field ${showExplanation ? "show" : "hide"}`}
            >
                <input
                    ref={explanationRef}
                    onChange={handleChangeExplanation}
                    type="text"
                    placeholder={t("Explain your choice (optional)...")}
                    disabled={disabled}
                />
            </div>
        </div>
        <div className="error_sect">
            {t(showError)}
        </div>
    </div>);
}

export default React.memo(Grading);
